import { userContextSelector } from 'core/userContext';
import { addNegativeToastWithErrorId } from 'modules/toastContainer';
import { useDispatch, useSelector } from 'react-redux';
import { getTriggerApiUrlForMedium } from '../components/Sections/utils';
import { useCampaignContext } from '../context';

export const COPY_SAMPLE_API_REQUEST_ERROR_MSG =
  'Could not copy api request to clipboard. Please try again.';

export const useSampleApiRequest = () => {
  const dispatch = useDispatch();

  const { campaign } = useCampaignContext();
  const { messageMedium } = campaign;

  const userContext = useSelector(userContextSelector);
  const { userId, email } = userContext;

  // Note: String literal formatting matters for codebox display and copying
  const sampleApiRequest = `
curl -XPOST '${getTriggerApiUrlForMedium(messageMedium)}' -H 'Api-Key: YOUR_API_KEY' -d '{
  "campaignId": ${campaign.id},
  "recipientEmail": "${email}",
  "recipientUserId": "${userId}",
  "dataFields": {
    "firstName": "Jane",
    "lastName": "Smith",
    "purchaseAmount": 42.42
  }
}'
`;

  const copySampleApiRequest = async () => {
    try {
      await navigator.clipboard.writeText(sampleApiRequest);
    } catch (error) {
      dispatch(
        addNegativeToastWithErrorId(
          COPY_SAMPLE_API_REQUEST_ERROR_MSG,
          'copySampleApiRequest',
          error,
        ),
      );
    }
  };

  return { sampleApiRequest, copySampleApiRequest };
};
